import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, map } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

import {
  DashboardSector,
  pathing,
  sector,
  Week,
} from '../interfaces/sectors.interface';
import { Uris } from 'src/app/Services/public/Uris';
import { GlobalFunction } from 'src/app/Services/public/globalFunction';
import { Report } from '../interfaces/reports.interface';

@Injectable({
  providedIn: 'root',
})
export class FieldSectorService {
  private pathingSector = new BehaviorSubject<pathing | null>(null);
  pathingSector$ = this.pathingSector.asObservable();

  private weekSector = new BehaviorSubject<Week | null>(null);
  weekSector$ = this.weekSector.asObservable();

  constructor(
    private http: HttpClient,
    public router: Router,
    public globalFunction: GlobalFunction
  ) {}
  setWeek(week: Week | null) {
    this.weekSector.next(week);
  }
  setPathingMap(path: pathing | null) {
    this.pathingSector.next(path);
  }

  getSectors(query: string): Observable<sector[]> {
    return this.http
      .get<sector[]>(
        `${Uris.API_SECTORS}${query ? query : ''}`,
        this.globalFunction.headers()
      )
      .pipe(
        map((resp: sector[]) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.globalFunction.validateError(err);
        })
      );
  }
  getDashboardSectorById(sector_id: number): Observable<DashboardSector> {
    return this.http
      .get<DashboardSector>(
        `${Uris.DASHBORARD}sector/${sector_id}/`,
        this.globalFunction.headers()
      )
      .pipe(
        map((resp: DashboardSector) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.globalFunction.validateError(err);
        })
      );
  }
  getSectorById(id: number): Observable<sector> {
    return this.http
      .get<sector>(`${Uris.API_SECTORS}${id}/`, this.globalFunction.headers())
      .pipe(
        map((resp: sector) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.globalFunction.validateError(err);
        })
      );
  }

  deleteSector(value: any): Observable<sector> {
    return this.http
      .delete<sector>(
        `${Uris.API_SECTORS}${value}/`,
        this.globalFunction.headers()
      )
      .pipe(
        map((resp: sector) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.globalFunction.validateError(err);
        })
      );
  }

  sectorRegister(sector: any): Observable<sector> {
    return this.http
      .post<sector>(
        `${Uris.API_SECTORS}`,
        sector,
        this.globalFunction.headers()
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.globalFunction.validateError(err);
        })
      );
  }

  editSector(value: any, id: any): Observable<sector> {
    return this.http
      .patch<sector>(
        `${Uris.API_SECTORS}${id}/`,
        value,
        this.globalFunction.headers()
      )
      .pipe(
        map((resp: any) => {
          return resp;
        }),
        catchError((err: any) => {
          return this.globalFunction.validateError(err);
        })
      );
  }
}
